import React, { useEffect, useState } from "react";
import "../Navbar/Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 1023,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1023);
      // Close menu when switching from mobile/tablet to desktop
      if (window.innerWidth > 1023 && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);

  // Update the handleScroll function in the useEffect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
        if (!menuOpen && !isClosing && !isMobileOrTablet) {
          setMenuOpen(true);
        }
      } else {
        setScrolled(false);
        if (menuOpen && !isClosing && !isMobileOrTablet) {
          // Only start closing if we're not already in the process
          if (!isClosing) {
            handleCloseMenu();
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuOpen, isClosing, isMobileOrTablet]);

  const handleCloseMenu = () => {
    setIsClosing(true);
    setTimeout(() => {
      setMenuOpen(false);
      setIsClosing(false);
    }, 500);
  };

  const toggleMenu = () => {
    if (menuOpen) {
      handleCloseMenu();
    } else {
      setMenuOpen(true);
    }
  };

  const closeMenuOnClick = () => {
    if (isMobileOrTablet) {
      handleCloseMenu();
    }
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-logo">
        <Link to="/">
          <img src="/logo.webp" alt="Logo" className="logo-img" />
        </Link>
      </div>
      <div
        className={`menu-links ${menuOpen ? "open" : ""} ${isClosing ? "closing" : ""}`}
      >
        <Link to="/" onClick={closeMenuOnClick}>
          Home
        </Link>
        <Link to="/aboutus" onClick={closeMenuOnClick}>
          About
        </Link>
        <Link to="/tour" onClick={closeMenuOnClick}>
          Tours
        </Link>
        <Link to="/destination" onClick={closeMenuOnClick}>
          Destinations
        </Link>
        <Link to="/contactus" onClick={closeMenuOnClick}>
          Contact
        </Link>
      </div>
      <div className="hamburger-wrapper" onClick={toggleMenu}>
        {menuOpen ? (
          <FaTimes className="hamburger-icon cross-icon" />
        ) : (
          <FaBars className="hamburger-icon" />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
